import { Navigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/store/authStore";

// Gate shell routes. While a hard-refresh bootstrap (token -> /me) is in flight we
// show a neutral loader so we don't flash the login screen for an authed operator.
export function ProtectedRoute() {
  const { t } = useTranslation();
  const isAuthed = useAuthStore((s) => s.isAuthed);
  const isBootstrapping = useAuthStore((s) => s.isBootstrapping);

  if (isBootstrapping) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-grey-50 text-[13px] text-grey-500">
        {t("app.loading")}
      </div>
    );
  }

  if (!isAuthed) return <Navigate to="/login" replace />;
  return <Outlet />;
}
